// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 230) return "static/chunks/230-fdefd236d0185f74.js";
	if (chunkId === 587) return "static/chunks/587-7c16ab401956176d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"77":"c2465b3c4ba2641b","521":"b8dda7180bd31603"}[chunkId] + ".js";
};